import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapSmall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.93774 13H22.2594",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0009 13L13.2473 23",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0009 13L13.2473 3",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 13L8.24621 18.3787",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 13.0001L8.24621 7.62134",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSwapSmall);
export default ForwardRef;
